import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Panel({ className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-panel", className), ...rest });
}
//# sourceMappingURL=Panel.js.map